export enum UserKeysTypes {
  ACCESS_TOKEN = 'accessToken',
  COMPANY_ID = 'companyId',
  EMAIL_ID = 'emailId',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE_NUMBER = 'phoneNumber',
  USER_ID = 'userId',
  USER_ROLE = 'userRole',
  USER_TYPE = 'userType',
  LOCATION = 'location',
}
export interface UserDefaultType { 
  accessToken: string; 
  companyId: string; //
  emailId: string; //
  firstName : string; // 
  lastName: string; //
  phoneNumber?: string;
  userId: string;
  userRole?: string;
  userType?: string;
  location?: string;
  locale?: string;
  default_language:string;
}
export interface UserContextType {
  getUserInfo: () => UserDefaultType | undefined
}

export interface UserData {
  user_first_name: string;
  user_last_name: string;
  user_email: string;
  companyId: string;
  default_queue:string;
  environment:string;
  location?: string;
}

export interface AuthUserData {
  accessToken: string;
  userId: string;
  customerName: string;
  userEmail: string;
}

export interface FirestoreUserData {
  engagementId: string;
  companyId: string;
  firstName: string;
  lastName: string;
  userEmail: string;
  location?: string;
  locale?: string;
  userId?: string;
  userType?:string;
  phoneNumber?:string;
}

export interface GSSUserInfo {
  smuser: string;
  uid: string;
  locale: string;
  'E-mail': string; 
  Last_Name: string;
  First_Name: string;
  usertype: string;
  clientIP: string;
  country: string;
}